export default "__VITE_ASSET__CvKlZwZZ__"